import type { ResponsiveValues } from '@lemonade-hq/uniclient-theme';
import { Layout, useResponsiveValue } from '@lemonade-hq/uniclient-theme';
import { clsx } from 'clsx';
import type { PropsWithChildren } from 'react';
import * as styles from './WizardLayoutContainer.css';

export type LayoutContainerColumns = ResponsiveValues<number> | number;

type LayoutContainerProps = PropsWithChildren & {
  readonly columns: LayoutContainerColumns;
  readonly className?: string;
  readonly noRowsBelowDesktop?: boolean;
};

export const WizardLayoutContainer: React.FC<LayoutContainerProps> = ({
  children,
  columns,
  className,
  noRowsBelowDesktop = false,
}) => {
  const responsiveLayoutColumns = useResponsiveValue(columns);

  return (
    <Layout
      className={clsx(styles.layoutContainer({ noRowsBelowDesktop }), className)}
      role="grid"
      style={{ [styles.layoutColumnsVarName]: responsiveLayoutColumns }}
    >
      {children}
    </Layout>
  );
};
